import React from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route, Redirect, RouteChildrenProps } from "react-router-dom";
import { PersonalTaxPage } from "./pages/personalTaxPage/PersonalTaxPage";
import { Header } from "./components/header/Header";
import { WhiteLabelProvider } from "./components/WhiteLabelProvider";
import { I18nContextProvider } from "./components/I18nContextProvider";
import { HelpDialogProvider } from "components/header/help/HelpDialogProvider";
import { WithBrowserWarning } from "components/withBrowserWarning/WithBrowserWarning";

interface RouteParams {
  year: string;
  company: string;
  language: string;
}

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Switch>
        <Route path="/web/index.php">
          {({ location }: RouteChildrenProps) => {
            const match = location.search.match("p=([a-z]*)");
            if (!match) {
              return <div>Unknown client</div>;
            }

            const companyAndLanguage = match[1];
            const language = companyAndLanguage.substring(companyAndLanguage.length - 2);
            const company = companyAndLanguage.substring(0, companyAndLanguage.length - 2);

            return <Redirect to={`/${company}/${language}`} />;
          }}
        </Route>
        <Route path="/:company/:language/">
          {({ match }: RouteChildrenProps<RouteParams>) => {
            return (
              <I18nContextProvider language={match!.params.language}>
                <WhiteLabelProvider company={match!.params.company}>
                  <WithBrowserWarning>
                    <HelpDialogProvider>
                      <Header />
                      <PersonalTaxPage />
                    </HelpDialogProvider>
                  </WithBrowserWarning>
                </WhiteLabelProvider>
              </I18nContextProvider>
            );
          }}
        </Route>
        <Route>
          {() => {
            if (process.env.NODE_ENV === "development") {
              return <Redirect to="/kbc/nl/" />;
            }

            return <div>Unknown client</div>;
          }}
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
